import React, {useEffect, useState} from 'react';
import {ReactComponent as AfricaSvg} from "./../../assets/svg/world/africa.svg";
import {ReactComponent as AmericaSvg} from "./../../assets/svg/world/america.svg";
import {ReactComponent as AsiaSvg} from "./../../assets/svg/world/asia.svg";
import {ReactComponent as EuropeSvg} from "./../../assets/svg/world/europe.svg";
import {ReactComponent as IranSvg} from "./../../assets/svg/world/iran.svg";
import {ReactComponent as AustraliaSvg} from "./../../assets/svg/world/australia.svg";
import {useTranslation} from "react-i18next";

const counts = [
	210000,//Iran
	6200,//Australia
	5700,//America
	245000,//Asia
	14300,//Europe
	9500,//Africa
]
const max = Math.max(...counts)

const WorldChart = () => {
	const { t } = useTranslation('common')
	return(
		<div className={'world-chart-wrap'}>
			<h3>{t('NumberEvent')}</h3>
			<div className={'world-chart-body'}>
				<ul>
					<li><ChartItem name={'Iran'} color={'#9f7c0f'} rectColor={'#ffe47b'} count={counts[0]} Icon={IranSvg}/></li>
					<li><ChartItem name={'Australia'} color={'#3297ab'} rectColor={'#6ff6e2'} count={counts[1]} Icon={AustraliaSvg}/></li>
					<li><ChartItem name={'America'} color={'#aa3fce'} rectColor={'#df9cf5'} count={counts[2]} Icon={AmericaSvg}/></li>
					<li><ChartItem name={'Asia'} color={'#de4a3a'} rectColor={'#fbbfb9'} count={counts[3]} Icon={AsiaSvg}/></li>
					<li><ChartItem name={'Europe'} color={'#58b2d4'} rectColor={'#bae5fc'} count={counts[4]} Icon={EuropeSvg}/></li>
					<li><ChartItem name={'Africa'} color={'#70a734'} rectColor={'#d6efb1'} count={counts[5]} Icon={AfricaSvg}/></li>
				</ul>
			</div>
		</div>
	)
}

const ChartItem = ({name,Icon,rectColor,color,count}) => {
	const [counter,setCounter] = useState(0)

	useEffect(()=>{
		const interval = setInterval(()=>{
			setCounter(prev=>{
				if(prev === count) {
					clearInterval(interval)
					return count
				}
				return prev+50
			})
		},0.01/count)
	},[])

	return(
		<div className={'w-chat-item'}>
			<div className={'rectangle'} style={{color,background:rectColor}}>
				<div className={'percent-rect'} style={{background:color,height:`${(counter*100/(max*1.25))}%`}}/>
				<span>{counter}+</span>
			</div>
			<Icon/>
			<span>{name}</span>
		</div>
	)
}

export default WorldChart;